// Location variants of a textblock. TextblockResponse.variants (GET /Textblock/GetAllNames and every other
// endpoint returning a TextblockResponse): [{ locationId, locationName, subject, body }], at most one per
// location. Mirrors the backend selection for event-related mails: the variant of the event's location if
// one exists, else the default text. Mails without an event (and the system blocks) always use the default.

const sameId = (a, b) => a != null && b != null && String(a) === String(b);

// Saved variants of a textblock, sorted by location name (tolerant: missing list → []).
export function textblockVariants(textblock) {
  const list = Array.isArray(textblock?.variants) ? textblock.variants : [];
  return [...list].sort((a, b) =>
    (a.locationName ?? '').localeCompare(b.locationName ?? '', 'de', { sensitivity: 'base' }));
}

// Variant of the textblock for a location, or null (no location / no variant there).
export function findTextblockVariant(textblock, locationId) {
  if (locationId == null || !Array.isArray(textblock?.variants)) return null;
  return textblock.variants.find(v => sameId(v.locationId, locationId)) ?? null;
}

// Text to use for a mail about an event at `locationId`: { subject, body, variant (dto | null) }.
export function pickTextblockContent(textblock, locationId) {
  const variant = findTextblockVariant(textblock, locationId);
  return {
    subject: (variant ? variant.subject : textblock?.subject) ?? '',
    body: (variant ? variant.body : textblock?.body) ?? '',
    variant,
  };
}

// Locations (from /Location/GetAll) that have no variant of this textblock yet — choices for "+ Variante".
export function locationsWithoutVariant(textblock, locations) {
  const taken = new Set((Array.isArray(textblock?.variants) ? textblock.variants : []).map(v => String(v.locationId)));
  return (Array.isArray(locations) ? locations : []).filter(l => !taken.has(String(l.id)));
}
